import type { RouteRecordRaw } from "vue-router"
import auth from "@/middlewares/auth"

const dialogueRoutes: RouteRecordRaw[] = [
  {
    path: "/mes-echanges",
    name: "dialogue-home",
    component: () => import("@/views/dialogue/DialogueHome.vue"),
    meta: {
      middleware: [auth],
      title: "space.dialogue",
    },
  },
  {
    path: "/mes-echanges/fiches/:destinationProviderId/mise-a-jour",
    name: "dialogue-destination-provider-update",
    component: () => import("@/views/dialogue/DestinationProviderUpdateForm.vue"),
    meta: {
      middleware: [auth],
      title: "space.dialogue_home.propose_update",
    },
  },
  {
    path: "/dialogue",
    redirect: { name: "dialogue-home" },
  },
  {
    path: "/dialogue/fiches/:destinationProviderId/mise-a-jour",
    redirect: (to) => ({
      name: "dialogue-destination-provider-update",
      params: to.params,
    }),
  },
]

export default dialogueRoutes
